import React from "react";

/**
 * SectionHeader — reusable section heading block.
 * Props: heading (string), subheading (string), centered (bool, default true)
 */
export const SectionHeader = ({ heading, subheading, centered = true }) => (
  <div className={`section-title${centered ? " text-center" : ""}`}>
    <h2>{heading}</h2>
    {subheading && <p>{subheading}</p>}
  </div>
);
